import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ScreeningDraftService } from '../../services/screening-draft.service';
import { ScreeningDraft } from 'src/app/models/screeningDraft';

@Component({
  selector: 'app-dob-dropdowns',
  templateUrl: './dob-dropdowns.component.html',
  styleUrls: ['./dob-dropdowns.component.less']
})
export class DobDropdownsComponent implements OnInit {

  constructor() { 
    console.log('dob dd loaded');
  }


  public dob_year: number;
  public dob_month: number;
  public dob_day: number;
  @Input() submitted : boolean;
  @Input() dsbl : boolean;
  @Input() public model : Date;
  @Output() dateChanged :EventEmitter<DOBUpdateModel> =new EventEmitter<DOBUpdateModel>();

  ngOnInit() {
    if(this.model){
      this.model = new Date(this.model)
      this.dob_year = this.model.getFullYear();
      this.dob_month = (this.model.getMonth() + 1);
      this.dob_day = this.model.getDate();
      this.updates({});

    }
  }
 
  updates($event : any){
    if(this.dob_day && this.dob_month && this.dob_year){
      let dob = new Date();
      dob.setDate(this.dob_day);
      dob.setMonth(this.dob_month -1);
      dob.setFullYear(this.dob_year);
      dob.setMinutes(0);
      dob.setHours(0);
      dob.setSeconds(0);
      this.model = dob;
      this.emitModel();
    }
  }

  emitModel(){
    let model = new DOBUpdateModel();
    model.dob = this.model;
    model.isMinor = this.applicantIsMinor;
    this.dateChanged.emit(model);
  }
 
  public get dobPartsMissing() : boolean {
    return (!this.dob_year || !this.dob_month || !this.dob_day)
  } 
  
  public get applicantIsMinor() : boolean {
    let minorAgeCutoff = new Date(); 
    minorAgeCutoff.setFullYear(new Date().getFullYear() - 18);
    if(!this.dob_year || !this.dob_day || !this.dob_month) return false;

    let currentDob = new Date(this.dob_year, this.dob_month-1, this.dob_day);
    return currentDob.valueOf() > minorAgeCutoff.valueOf();
  }

  public get dob_months(): number[] {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  };

  public get dob_days(): number[] {
    let output: number[] = [];
    let days: number = new Date(this.dob_year ? this.dob_year : 2003, this.dob_month, 0).getDate();

    for (let index = 1; index <= days; index++) {
      output.push(index);
    }
    return output;
  }

  public get dob_years(): number[] {
    let output: number[] = [];
    let currentYear = new Date().getFullYear();

    //start with currentYear-18, since we don't allow minors, then work down to have a desc list
    for (let index = currentYear - 18; index > currentYear - 100; index--) {
      output.push(index);
    }
    return output;
  }



}


export class DOBUpdateModel
{
  dob: Date;
  isMinor : boolean;
}

